var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.altText,"title":_vm.altText}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.displayName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }